import { GzDashboardSettingsPanelWebComponent } from './component/GzDashboardSettingsPanelWebComponent';
export { GzDashboardSettingsPanelWebComponent };
